import React from "react";

import { LogoLoader } from "@performyard/py-components";

/**
 * The waiting state shown after the wizard's launch is accepted, while the fan-out job
 * creates a workflow per subject. Mirrors the review-cycle build state
 * (`pages/ReviewCycle/Details/LoadingStates/ReviewCycleLoader`): a full white pane with
 * the loader centered, rather than the legacy background-jobs label / job progress page.
 */
export const LaunchingLoader = () => (
	<div className="flex h-full flex-col items-center justify-center bg-neutral-0" data-testid="launching-loader">
		<LogoLoader textArray={[]} mainText="Launching Your Workflow..." />
	</div>
);
